'use client';
import { useEffect } from 'react';
import Link from 'next/link';
import { useRouter, usePathname } from 'next/navigation';

import styles from '@/app/_components/layout/Header.module.scss';
import FlexBox from '@/app/_components/container/FlexBox';
import Logo from '@/app/_components/common/logo/Logo';
import GNB from '@/app/_components/common/gnb/GNB';
import GNBItem from '@/app/_components/common/gnb/GNBItem';
import IconHome from '@/app/_images/ico_home.svg';
import IconPlus from '@/app/_images/ico_plus.svg';
import Text from '@/app/_components/common/text/Text';
import Button from '@/app/_components/common/button/Button';
import Dropdown from '@/app/_components/common/dropdown/Dropdown';
import DropdownMobileMenu from '@/app/_components/layout/mobileMenu/DropdownMobileMenu';

import { DROPDOWN_ITEMS } from '@/app/_contants/dropdownItems';
import { useLoggedInStore } from '@/app/_stores/loggedInStore';
import useGetLoggedInfo from '@/app/_hooks/queries/useGetLoggedInfo';
import { useQueryParamsStore } from '@/app/_stores/queryParamsStore';
import { ROUTER_PATH } from '@/app/_contants/routerPath';

const HeaderContent = () => {
  const router = useRouter();
  const path = usePathname();
  const { setCurrentPage, setSelectedFilter } = useQueryParamsStore();

  const { data, isPending } = useGetLoggedInfo();

  const { isLoggedIn, setIsLoggedIn } = useLoggedInStore();
  const pathResult = path.includes('result');
  const pathAccount = path.includes('account');

  useEffect(() => {
    if (!data || isPending) return;

    if (data.loggedStatus !== isLoggedIn) {
      setIsLoggedIn(data.loggedStatus);
    }

    const currentPath = window.location.pathname;
    if (
      !data.loggedStatus &&
      currentPath !== ROUTER_PATH.MAIN &&
      currentPath !== ROUTER_PATH.ABOUT
    ) {
      router.push(ROUTER_PATH.MAIN);
    }
  }, [data, isLoggedIn, isPending]);

  const onClickList = () => {
    setSelectedFilter('all');
    setCurrentPage(1);
  };

  return (
    <>
      <FlexBox className={styles.start}>
        <Logo />
        <GNB>
          {isLoggedIn && (
            <>
              <GNBItem>
                <Link
                  className={`${pathResult ? 'text-primary' : ''}`}
                  href={`${ROUTER_PATH.RESULTS}?page=1&inspect_type=all`}
                  onClick={onClickList}
                >
                  <IconHome />
                  <Text size={'lg'}>結果リスト</Text>
                </Link>
              </GNBItem>
              <GNBItem>
                <Link href={'https://manual.muhayu.com/gpt-killer'} target="_blank">
                  <Text size={'lg'}>よくある質問</Text>
                </Link>
              </GNBItem>
              <GNBItem>
                <Link href={'https://forms.gle/8t6yyQAqjJDUiJUE9'} target="_blank">
                  <Text size={'lg'}>フィードバック</Text>
                </Link>
              </GNBItem>
            </>
          )}
        </GNB>
      </FlexBox>

      <FlexBox className={styles.end}>
        <GNB>
          {!isLoggedIn && (
            <GNBItem className={styles.itemLogin}>
              <Button tag="a" href={ROUTER_PATH.LOGIN} variants="text-primary">
                ログイン
              </Button>
            </GNBItem>
          )}
          {data && (
            <GNBItem className={styles.itemUpload}>
              <Button tag="a" href={isLoggedIn ? ROUTER_PATH.UPLOAD : ROUTER_PATH.LOGIN}>
                {isLoggedIn && <IconPlus width={20} height={20} />}
                {isLoggedIn ? `新規アップロード` : '無料で試す'}
              </Button>
            </GNBItem>
          )}
          {isLoggedIn && (
            <GNBItem className={styles.itemLast}>
              <span className={styles.vline}></span>
              <Dropdown items={DROPDOWN_ITEMS} checkIndex={pathAccount ? 0 : undefined} />
            </GNBItem>
          )}
        </GNB>
      </FlexBox>

      {/* 모바일 네비게이션 */}
      {isLoggedIn && <DropdownMobileMenu />}
    </>
  );
};

export default HeaderContent;
